import { PaymentUtilService } from './../../services/payment-util/payment-util.service';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { timer, Subscription } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { UtilService, PaymentService, VariablesService, VwoService, EventsService } from '../../../../shared/services';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IUser } from 'src/app/shared/models';

@Component({
  selector: 'app-upi',
  templateUrl: './upi.component.html',
  styleUrls: ['./upi.component.scss']
})
export class UpiComponent implements OnInit, OnDestroy {

  readonly vars = inject(VariablesService);

  @Input() cartDetails;
  @Input() isOrderLoading;
  @Input() qrURL;
  @Input() origin;
  @Input() campaignId;
  @Input() customTag;
  @Input() option;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  @Output() disableOptions: EventEmitter<any> = new EventEmitter();
  @Output() cardDetailsEmit: EventEmitter<any> = new EventEmitter();

  upiForm: FormGroup;
  upiInput = new FormControl('', [Validators.required, Validators.pattern(this.vars.upi_regex)]);
  countdown;
  timerSub: Subscription;

  generalSubs: Subscription[] = [];
  isMobile;

  iosSupportedIntent = ['BHIM', 'GooglePay', 'Paytm', 'PhonePe'];

  upiOffers: any = [];
  userData: IUser;
  recommendedVpa = '';

  inputFieldData = {
    vpa: ''
  };

  constructor(
    public utilService: UtilService,
    public paymentService: PaymentService,
    private router: Router,
    private dialog: MatDialog,
    public vwo: VwoService,
    public paymentUtilService: PaymentUtilService,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.userData = this.utilService.getUserData();
    if (this.userData?.lastorder?.payment_mode_value === 'VPA') {
      this.recommendedVpa = this.userData?.lastorder?.checksum || '';
    }
    if (this.option?.payment_offers?.length > 0) {
      this.upiOffers = this.option?.payment_offers?.filter((item => item?.mode === 'UPI'));
    }

    this.isMobile = this.utilService?.isMobile();
    this.vars.upiTimerOuter.subscribe(res => {
      if (res) {
        this.startTimer(5 * 60);
      }
    });
    this.upiForm = new FormGroup({
      upiInput: this.upiInput
    });

    this.prefillUpiId();
    if (!this.isMobile) {
      this.vars.getCartInsurance.subscribe(res => {
        if (res) {
          this.cardDetailsEmit.emit(res);
        }
      });
    }

    this.upiInput.valueChanges.subscribe(val => {
      if (this.inputFieldData.vpa === val) return;
      this.inputFieldData.vpa = val;
      this.onVpaFocusOut();
    });
  }

  /** Prefill UPI id from last order */
  prefillUpiId() {
    this.generalSubs.push(this.vars.lastOrderInfo.subscribe({
      next: (res) => {
        this.recommendedVpa = this.recommendedVpa || res?.upi_id || res?.checksum || this.option?.RECOMMENDED_VPA || '';
        if (this.recommendedVpa && this.vars.upi_regex.test(this.recommendedVpa.replaceAll('*', 'a'))) {
          this.upiInput.setValue(this.recommendedVpa);
          this.updateValidation('vpa', true);
        }
        this.vars.recommendedVpa = this.upiInput.value;
        this.prefillEvent({ info_1: this.upiInput.value ? 'yes' : 'no' });
      }
    }));
  }

  onVpaFocusOut() {
    if (this.upiInput?.value === this.recommendedVpa) {
      this.updateValidation('vpa', true);
    } else {
      this.updateValidation('vpa', true, this.vars.upi_regex);
    }
  }

  updateValidation(field: 'vpa', require: boolean, pattern?: any ) {
    const validators = [];
    if (require) validators.push(Validators.required);
    if (pattern) validators.push(Validators.pattern(pattern));
    if (field === 'vpa') {
      this.upiInput.clearValidators();
      this.upiInput.addValidators(validators);
      this.upiInput.updateValueAndValidity();
    }
  }

  prefillEvent(prop: { info_1: 'yes' | 'no' }) {
    this.events.sendSystemEvent({
      eventName: 'vpa_prefill',
      info_1: prop.info_1,
      info_2: this.vars.recommendedVpa
    }).subscribe(_ => _);
  }

  /**Cancel the payment */
  cancelPayment() {
    this.upiInput.enable();
    this.vars.upiTimer = false;
    this.vars.upi_payment_status.next('canceled');
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
    this.disableOptions.next(false);
  }

  /**Countdown timer */
  startTimer(duration) {
    this.upiInput.disable();
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.timerSub = timer(0, 1000).pipe(
      take(duration),
      map(counter => {
        const remaining = duration - counter - 1;
        if (remaining <= 0) {
          this.cancelPayment();
        }
        const minutes = Math.floor(remaining / 60).toString().padStart(2, '0');
        const seconds = (remaining % 60).toString().padStart(2, '0');
        this.countdown = `${minutes} : ${seconds}`;
        return remaining;
      })
    ).subscribe();
  }

  /**submit the payment */
  submit() {
    if (this.upiForm.valid) {
      this.isOrderLoading = true;
      const payload = {
        'vpa': this.upiInput.value
      };
      if (this.vars.isAutoLogin) {
        payload['vpa_type'] = this.upiInput?.value?.includes('*') ? 'lastused' : 'custom';
      }
      this.checkUpiIdValidation(payload);
    } else {
      this.utilService.checkValidForm(this.upiForm);
    }
  }

  checkUpiIdValidation(payload) {
    // this.paymentService.vpaIdValidation(payload).subscribe((res: any) => {
    //   if (res.data && res.data.isVPAValid) {
    //     this.isOrderLoading = true;
    //     // this.vars.upiTimer = true;
        this.startTimer(5 * 60);
        this.disableOptions.next(true);
        const data = {
          mode: 'UPI',
          mode_value: 'VPA',
          VPA: payload.vpa,
          origin: 'payment_form',
          vpa_type: payload?.vpa_type || null
        };
        this.dataEmit.emit(data);
        this.isOrderLoading = false;
        this.checkVpaResponse();
    //   } else {
    //     this.utilService.openSnackBar('Please enter valid UPI Address', 'error');
    //     this.isOrderLoading = false;
    //   }
    // }, () => {
    //   this.isOrderLoading = false;
    // });
  }

  submitOrderMobile(mode, mode_value) {
    if (this.isOrderLoading) { return; }
    const data = {
      mode: mode,
      mode_value: mode_value,
    };
    this.checkVpaResponse();
    this.dataEmit.emit(data);
  }

  checkVpaResponse() {
    this.startTimer(5 * 60);
    this.generalSubs.push(
      this.vars.upi_payment_status.subscribe(val => {
        if (val === 'success') {
          this.dialog.closeAll();
          this.router.navigate(['/new/payment-route'], {
            queryParams: this.vars.tyParams
          });
        } else if (val === 'failed') {
          this.cancelPayment();
        } else if (val === 'canceled') {
          this.isOrderLoading = false;
        }
      })
    );
  }

  /**Get the keys from the object of the options */
  getObjectKeys(obj) {
    if (obj) {
      return Object.keys(obj);
    }
  }

  upiInputSubmit(data) {
    const payload = {
      vpa: data?.upi,
      vpa_type: data?.vpa_type,
    };
    this.checkUpiIdValidation(payload);
  }

  ngOnDestroy() {
    this.generalSubs.forEach(s => s.unsubscribe());
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

}
